// extracted by mini-css-extract-plugin
export var avatarContainer = "_gf-0";
export var avatarTypingWave = "_gf-i";
export var gray = "_gf-f";
export var green = "_gf-c";
export var icon = "_gf-9";
export var image = "_gf-1";
export var lg = "_gf-6";
export var md = "_gf-5";
export var presenceDot = "_gf-b";
export var red = "_gf-d";
export var sm = "_gf-4";
export var status = "_gf-a";
export var typingDot = "_gf-h";
export var typingPill = "_gf-g";
export var xl = "_gf-7";
export var xs = "_gf-3";
export var xxl = "_gf-8";
export var xxs = "_gf-2";
export var yellow = "_gf-e";